import { render, staticRenderFns } from "./landingInformation.vue?vue&type=template&id=4a628798&"
import script from "./landingInformation.vue?vue&type=script&lang=js&"
export * from "./landingInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports